// rg4js is loaded as a global from the Raygun CDN script in index.html
declare global {
  interface Window {
    rg4js?: (command: string, data?: unknown) => void
  }
}

interface UserContext {
  username?: string
  email?: string
  firstName?: string
  lastName?: string
  userId?: number | string
  userType?: string
  roleNames?: string[]
}

export const errorReporting = {
  initialized: false,
  customUserData: null as Record<string, unknown> | null,

  init(key: string): void {
    try {
      if (!this.initialized && !!key && !!window.rg4js) {
        window.rg4js('apiKey', key)
        window.rg4js('enableCrashReporting', true)
        window.rg4js('options', {
          allowInsecureSubmissions: false,
          ignoreAjaxAbort: true,
          ignoreAjaxError: false,
          debugMode: false,
          ignore3rdPartyErrors: true,
          wrapAsynchronousCallbacks: true,
          excludedHostnames: [],
          excludedUserAgents: ['HeadlessChrome'],
          disableErrorTracking: false,
          disablePulse: true,
        })
        this.initialized = true
      }
    } catch (e) {
      console.error('errorReporting.init failed:', e)
    }
  },

  setContext(user: UserContext): void {
    try {
      if (window.rg4js) {
        window.rg4js('setUser', {
          identifier: user.username,
          isAnonymous: false,
          email: user.email,
          firstName: user.firstName,
          fullName: user.firstName + ' ' + user.lastName,
          uuid: String(user.userId),
        })
      }
      this.customUserData = {
        userType: user.userType,
        roleNames: user.roleNames,
      }
    } catch (e) {
      console.error('errorReporting.setContext failed:', e)
    }
  },

  clearContext(): void {
    try {
      if (window.rg4js) {
        window.rg4js('setUser', {
          identifier: '',
          isAnonymous: true,
          email: '',
          firstName: '',
          fullName: '',
          uuid: '',
        })
      }
      this.customUserData = null
    } catch (e) {
      console.error('errorReporting.clearContext failed:', e)
    }
  },

  send(error: Error | unknown, customData?: Record<string, unknown>): void {
    try {
      if (window.rg4js) {
        const mergedData = { ...this.customUserData, ...customData }
        window.rg4js('send', { error: error, customData: mergedData })
      }
    } catch (e) {
      console.error('errorReporting.send failed:', e)
    }
  },
}
